import { WidgetDefinition } from '../models/WidgetDefinition';

export const GroupStatesWidgetDefinition: WidgetDefinition = {
    baseType: 'GroupStates',
    group: 'Charts',
    hasImage: true,
    highlights: ['Graphical representation of group states', 'By frequency or as a timeline'],
    icon: 'fa-area-chart',
    sortingOrder: 700,
    title: 'Group states',
    type: 'GroupStates'
};